import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React from 'react';

import styles from './index.module.scss';

export class DangerButton extends React.PureComponent<ButtonProps> {
  render(): React.ReactNode {
    const { children, disabled, loading, onClick } = this.props;
    return <div className={styles.container}>
      <Button
        type="primary"
        className={styles.dangerButton}
        disabled={disabled}
        loading={loading}
        onClick={onClick}
      >
        {children}
      </Button>
    </div>;
  }
}
